import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { IconFactory } from "../../factories/IconFactory";
import { EditorComponentContract } from '../EditorComponentContract'

export class Icon extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new IconFactory
  }

  elementIds() {
    return ['containerId', 'id']
  }

  elementClasses() {
    return ['classes', 'iconClasses']
  }

  elementContents() {
    return ['class', 'icon']
  }

  elementStyles() {
    return [
      {id: 'containerId', element: 'id', styles: 'styles', selector: '#', variation: null},
      {id: 'id', element: 'id', styles: 'iconStyles', selector: '#', variation: null},
    ]
  }

  info() {
    return {
      name: 'Icon',
      icon: 'fa-star',
      variations: this.variationsInfo()
    }
  }
}
